import * as React from "react";
import { IFormItem } from "../../../../../model/editform/FormItem";
import { EditFormItemTypes } from "../../../../../common/Constants";
import { Form, Input, Checkbox, Select } from "antd";
import TextArea from "antd/lib/input/TextArea";

const SimpleFormItem = ({
  getFieldDecorator,
  translate,
  item,
  rowData
}: {
  getFieldDecorator: any;
  translate: any;
  item: IFormItem;
  rowData: any;
}) => {
  switch (item.type) {
    case EditFormItemTypes.INPUT:
      return (
        <Form.Item key={item.name} label={translate(`edit_form.${item.name}`)}>
          {getFieldDecorator(item.name, {
            initialValue: rowData && rowData[item.name],
            rules: [
              {
                required: item.displayConfiguration.required,
                message: translate("edit_form.required_message", {
                  field: translate(`edit_form.${item.name}`)
                })
              }
            ]
          })(
            <Input
              readOnly={rowData && item.displayConfiguration.readOnly}
              maxLength={item.displayConfiguration.maxLength}
            />
          )}
        </Form.Item>
      );

    case EditFormItemTypes.TEXTAREA:
      return (
        <Form.Item key={item.name} label={translate(`edit_form.${item.name}`)}>
          {getFieldDecorator(item.name, {
            initialValue: rowData && rowData[item.name],
            rules: [
              {
                required: item.displayConfiguration.required,
                message: translate("edit_form.required_message", {
                  field: translate(`edit_form.${item.name}`)
                })
              }
            ]
          })(
            <TextArea
              readOnly={rowData && item.displayConfiguration.readOnly}
              autoSize={{ minRows: item.displayConfiguration.minRows }}
              maxLength={item.displayConfiguration.maxLength}
            />
          )}
        </Form.Item>
      );

    case EditFormItemTypes.CHECKBOX:
      return (
        <Form.Item key={item.name} label={translate(`edit_form.${item.name}`)}>
          {getFieldDecorator(item.name, {
            initialValue:
              (rowData && rowData[item.name]) ||
              item.displayConfiguration.checked,
            valuePropName: "checked"
          })(<Checkbox />)}
        </Form.Item>
      );

    case EditFormItemTypes.SELECT:
      return (
        <Form.Item key={item.name} label={translate(`edit_form.${item.name}`)}>
          {getFieldDecorator(item.name, {
            initialValue: rowData && rowData[item.name]
          })(
            <Select
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
            >
              {item.items &&
                item
                  .items()
                  .map(selectItem => (
                    <Select.Option key={selectItem.id}>
                      {selectItem.name}
                    </Select.Option>
                  ))}
            </Select>
          )}
        </Form.Item>
      );

    default:
      return <React.Fragment></React.Fragment>;
  }
};

export default SimpleFormItem;
